/*global google*/

import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import Geosuggest from 'react-geosuggest';

import { FormRow, Input, MainBtn, CancelBtn, CompanyUserSelect } from '../Common/form/Elements-export';
import { editCompany } from './epics-companies';
import { StaticRoutePaths } from '../Common/ClientRoutes';

import Svgs from '../Common/Svgs';

import localStorage from '../Common/LocalStorage';
import LocalizedStrings from 'react-localization';
import { translations } from '../Common/Translations';
import { UserRole } from '../Common/UserRole';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang') !== undefined ? localStorage.getFromStorage('lang') : 'en');

class EditCompany extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userIdentifier: 1,
            companyId: this.props.selectedCompany.id,
            companyOwner: this.props.selectedCompany.ownerName,
            loadingSpinner: false,
            userRole: localStorage.getFromStorage('role'),
            name: this.props.selectedCompany ? this.props.selectedCompany.name : ' ',
            address: {
                name: this.props.selectedCompany ? this.props.selectedCompany.address.name : ' ',
                latitude: this.props.selectedCompany ? this.props.selectedCompany.address.latitude : ' ',
                longitude: this.props.selectedCompany ? this.props.selectedCompany.address.longitude : ' '
            },
            phone: this.props.selectedCompany ? this.props.selectedCompany.phone : ' ',
            validation: {
                name: ' ',
                address: ' ',
                phone: ' '
            }
        };
    }

    update = type => e => {
        this.setState({ ...this.state, [type]: e.target.value });
    };

    onSuggestSelect = suggest => {
        if (suggest !== undefined) {
            this.setState({
                ...this.state,
                address: {
                    name: suggest.label ? suggest.label : '',
                    latitude: (suggest.location && suggest.location.lat) ? suggest.location.lat.toString() : '0.00',
                    longitude: (suggest.location && suggest.location.lat) ? suggest.location.lng.toString() : '0.00'
                }
            });
        }
    };

    cleanSuggest = event => {
        if (event === '') {
            this.setState({
                ...this.state,
                address: {
                    name: '',
                    latitude: '',
                    longitude: ''
                }
            });
        }
    };

    editCompanyHandler = () => {
        this.setState({
            ...this.state,
            loadingSpinner: true
        });
        editCompany(this.props.selectedCompany.id, this.state)
            .then(() => {
                this.setState({
                    ...this.state,
                    loadingSpinner: false
                });
                if (this.state.userRole === UserRole.STORE_OWNER) {
                    this.props.history.push(StaticRoutePaths.INFO_COMPANY);
                } else {
                    this.props.history.push(StaticRoutePaths.COMPANIES);
                }
            })
            .catch(error => {
                this.setState({
                    ...this.state,
                    loadingSpinner: false,
                    validation: {
                        name: this.generateErrors(error.body, 'name')
                            .join(' ')
                            .trim(),
                        address: this.generateErrors(error.body, 'address.name')
                            .join(' ')
                            .trim(),
                        phone: this.generateErrors(error.body, 'phone')
                            .join(' ')
                            .trim()
                    }
                });
            });
    };

    generateErrors = (errArray, errName) => {
        return errArray.map(singleErr => {
            return singleErr.property_path === errName ? singleErr.message : '';
        });
    };

    showErrors = message => (message === '' ? null : <div className="qf-error-message">{message}</div>);

    cancelCompanyHandler = () => {
        let direction =
            this.state.userRole === UserRole.STORE_OWNER
                ? this.props.history.push(StaticRoutePaths.INFO_COMPANY)
                : this.props.history.push(StaticRoutePaths.COMPANIES);
        return direction;
    };

    componentDidMount() {
        this.props.update('companyOwnerList', this.state.userIdentifier, this.state.companyId);
    }

    render() {
        return (
            <div className="container">
                <div className="row qf-mb-100">
                    <div className="col-1 light-blue-bg text-center pt-3">
                        <span className="qf-page-icon">{Svgs.companies}</span>
                    </div>
                    <div className="col-11 white-bg px-5">
                        <div className="row">
                            <div className="col-9">
                                <h2 className="qf-page-title">
                                    <i className="fa fa-pencil-square mr-2" />
                                    {strings.edit_company}
                                </h2>
                            </div>
                            <div className="col-3 align-self-center text-right">
                                {this.state.userRole === UserRole.STORE_OWNER ? (
                                    <Link to={StaticRoutePaths.INFO_COMPANY} className="qf-back-btn">
                                        <i className="fa fa-chevron-left" />
                                        {strings.back}
                                    </Link>
                                ) : (
                                    <Link to={StaticRoutePaths.COMPANIES} className="qf-back-btn">
                                        <i className="fa fa-chevron-left" />
                                        {strings.back}
                                    </Link>
                                )}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <hr className="qf-divider-line" />
                            </div>
                        </div>
                        <FormRow>
                            <Input
                                value={this.state.name}
                                handler={this.update('name')}
                                inputType="text"
                                label={`* ${strings.company_name}`}
                                placeholder={strings.company_name}
                                extraClasses={this.state.userRole === UserRole.ADMIN ? 'col-sm-6' : 'col-sm-12'}
                            />
                            {this.state.userRole === UserRole.ADMIN ? (
                                <CompanyUserSelect
                                    {...this.props}
                                    companyOwner={this.state.companyOwner}
                                    handler={this.update('companyOwnerId')}
                                    label={`* ${strings.company_owner}`}
                                    placeholder={strings.company_owner}
                                    selectDefault={strings.select_company_owner}
                                    extraClasses="col-sm-6"
                                />
                            ) : null}
                            <div className={this.state.userRole === UserRole.ADMIN ? 'col-sm-6' : 'col-sm-6'}>
                                {this.showErrors(this.state.validation.name)}
                            </div>
                        </FormRow>
                        <FormRow>
                            <div
                                className={
                                    this.state.userRole === UserRole.ADMIN
                                        ? 'formInput col-sm-6 qf-address'
                                        : 'formInput col-sm-12 qf-address'
                                }
                            >
                                <label>
                                    * {strings.address} <span className="qf-small-label-desc">({strings.mailing_purposes_only})</span>
                                    <i className="fa fa-map-marker" aria-hidden="true" />
                                </label>
                                <Geosuggest
                                    ref={el => (this._geoSuggest = el)}
                                    onBlur={this.cleanSuggest}
                                    placeholder={strings.search_places}
                                    initialValue={this.state.address.name}
                                    onSuggestSelect={this.onSuggestSelect}
                                    location={new google.maps.LatLng(53.558572, 9.9278215)}
                                    radius="20"
                                />
                                <span style={{ fontStyle: 'italic', color: '#858585' }}>
                                    {strings.select_address_from_suggest_list_edit}
                                </span>
                            </div>
                            <Input
                                value={this.state.phone}
                                handler={this.update('phone')}
                                inputType="text"
                                label={`* ${strings.phone}`}
                                placeholder={strings.work_phone}
                                extraClasses={this.state.userRole === UserRole.ADMIN ? 'col-sm-6' : 'col-sm-12'}
                            />
                            <div className={this.state.userRole === UserRole.ADMIN ? 'col-sm-6' : 'col-sm-12'}>
                                {this.showErrors(this.state.validation.address)}
                            </div>
                            <div className={this.state.userRole === UserRole.ADMIN ? 'col-sm-6' : 'col-sm-12'}>
                                {this.showErrors(this.state.validation.phone)}
                            </div>
                        </FormRow>
                        <FormRow>
                            <div className="col-2 offset-8 qf-mb-30">
                                {this.state.loadingSpinner ? (
                                    <div className="px-5 text-center p-3" />
                                ) : (
                                    <CancelBtn
                                        onclick={this.cancelCompanyHandler}
                                        title={strings.cancel}
                                        extraClasses="qf-gray-btn w-100 mt-4"
                                    />
                                )}
                            </div>

                            <div className="col-2 qf-mb-30">
                                {this.state.loadingSpinner ? (
                                    <div className="col-11 white-bg px-5 text-center p-3">
                                        <i className="fa fa-spinner fa-spin fa-2x" style={{ color: '#858585' }} />
                                    </div>
                                ) : (
                                    <MainBtn
                                        onclick={this.editCompanyHandler}
                                        title={strings.save_company}
                                        extraClasses="qf-blue-btn w-100 mt-4"
                                    />
                                )}
                            </div>
                        </FormRow>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(EditCompany);



// WEBPACK FOOTER //
// ./src/customModules/Companies/component-edit-company.js